import { render, staticRenderFns } from "./CustomerHealth.vue?vue&type=template&id=4df92e7b&scoped=true"
import script from "./CustomerHealth.vue?vue&type=script&lang=js"
export * from "./CustomerHealth.vue?vue&type=script&lang=js"
import style0 from "./CustomerHealth.vue?vue&type=style&index=0&id=4df92e7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df92e7b",
  null
  
)

export default component.exports